export default __webpack_public_path__ + "static/media/coupon.6b67bba1.svg";